<div class="modal-header">
  <h3 class="modal-title" i18n="@@addOn">Add-on</h3>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="addon_info">
  <p i18n="@@travelCardInfo">
    Unlimited journey on all London Underground, Buses, Trams, Docklands Light Rail, Over-ground
    Trains and National Rail Services within zones of the selected travelcard. The costs shown in
    the grid are for an individual traveller. Please note that the Peak travel period is before
    09.30 on weekdays.
  </p>
  <p class="red-alert" i18n="@@Add-OnTravelcards">
    Note: Add-On Travelcards are not compatible with the E-Ticket delivery method.
  </p>
</div>
<b class="travelcard_header" i18n="@@travelCardSelection">Travelcard Selection</b>
<div class="modal-body flex-row-container flex-column-mobile">
  <div class="travel-card-item">
    @if (noOfCards >= 1) {
      <div class="flex-column-container travel-card-box">
        <p i18n="@@travelCardDate">Date of Travel:</p>
        <ngbd-datepicker-i18n class="date">
          <i
            class="ico-calendar combo-box-icon cursor_pointer"
            aria-hidden="true"
            (click)="d1.toggle()"
          ></i>
          <input
            autocomplete="off"
            placeholder="DD/MM/YYYY"
            i18n-placeholder
            class="combo-box"
            [minDate]="startDate"
            [startDate]="startDate"
            [(ngModel)]="bookingDate[0]"
            [navigation]="'arrows'"
            (click)="d1.toggle(); updateState()"
            ngbDatepicker
            #d1="ngbDatepicker"
            name="dp1"
            firstDayOfWeek="7"
            id="dp1"
            [markDisabled]="isDisabled"
            [container]="'body'"
            aria-labelledby="rail-outbound-date"
          />
          <!-- <i class="ico-clock combo-box-icon combo-box-icon--right"></i> -->
          <span id="rail-outbound-date" hidden i18n="AriaRailOutboundDate">Outbound date</span>
        </ngbd-datepicker-i18n>
        <div class="flex-row-container">
          <p class="london_zones london_zones_1" i18n="@@travelCardZone4">London Zone 1-4</p>
          <p class="london_zones london_zones_2" i18n="@@travelCardZone6">London Zone 1-6</p>
        </div>
        <div class="flex-row-container">
          <mat-button-toggle-group
            multiple
            (change)="toggleChange($event, 0)"
            class="toggle_group"
            [hideMultipleSelectionIndicator]="hideMultipleSelectionIndicator()"
            name="card-0"
          >
            @for (
              extra of outboundRailJourneyOption?.ticketExtras;
              track extra;
              let index = $index
            ) {
              <div class="flex-column-container toggle_container">
                <p>{{ extra?.description?.includes('Peak') ? 'Off-Peak' : 'Peak' }}</p>
                @if (isAdult) {
                  <mat-button-toggle
                    class="peak_button"
                    value="{{ extra?.adultAmount }}-{{ index }}"
                    (click)="updateTravelCard(0, extra)"
                    >{{
                      extra?.adultAmount | currency: extra?.currency : 'symbol'
                    }}</mat-button-toggle
                  >
                }
                @if (isChild) {
                  <mat-button-toggle
                    class="peak_button"
                    value="{{ extra?.childAmount }}-{{ index }}"
                    (click)="updateTravelCard(0, extra)"
                    >{{
                      extra?.childAmount | currency: extra?.currency : 'symbol'
                    }}</mat-button-toggle
                  >
                }
              </div>
            }
          </mat-button-toggle-group>
        </div>
      </div>
    }
  </div>
  @if (noOfCards >= 2) {
    <div class="travel-card-item">
      <div class="flex-column-container travel-card-box">
        <p i18n="@@travelCardDate">Date of Travel:</p>
        <ngbd-datepicker-i18n class="date">
          <i
            class="ico-calendar combo-box-icon cursor_pointer"
            (click)="d2.toggle()"
            aria-hidden="true"
          ></i>
          <input
            autocomplete="off"
            placeholder="DD/MM/YYYY"
            i18n-placeholder
            class="combo-box"
            [minDate]="startDate"
            [startDate]="startDate"
            [(ngModel)]="bookingDate[1]"
            [navigation]="'arrows'"
            (click)="d2.toggle(); updateState()"
            ngbDatepicker
            #d2="ngbDatepicker"
            name="dp2"
            [markDisabled]="isDisabled"
            id="dp2"
            firstDayOfWeek="7"
            [container]="'body'"
            aria-labelledby="rail-outbound-date"
          />
          <!-- <i class="ico-clock combo-box-icon combo-box-icon--right"></i> -->
          <span id="rail-outbound-date" hidden i18n="AriaRailOutboundDate">Outbound date</span>
        </ngbd-datepicker-i18n>
        <div class="flex-row-container">
          <p class="london_zones london_zones_1" i18n="@@travelCardZone4">London Zone 1-4</p>
          <p class="london_zones london_zones_2" i18n="@@travelCardZone6">London Zone 1-6</p>
        </div>
        <div class="flex-row-container">
          <mat-button-toggle-group
            [disabled]="!bookingDate[1]"
            multiple
            (change)="toggleChange($event, 1)"
            [hideMultipleSelectionIndicator]="hideMultipleSelectionIndicator()"
            class="toggle_group"
            name="card-1"
          >
            @for (
              extra of outboundRailJourneyOption?.ticketExtras;
              track extra;
              let index = $index
            ) {
              <div class="flex-column-container toggle_container">
                <p>{{ extra?.description?.includes('Peak') ? 'Off-Peak' : 'Peak' }}</p>
                @if (isAdult) {
                  <mat-button-toggle
                    [disabled]="!bookingDate[1]"
                    class="peak_button"
                    value="{{ extra?.adultAmount }}-{{ index }}"
                    (click)="bookingDate[1] ? updateTravelCard(1, extra) : null"
                    >{{
                      extra?.adultAmount | currency: extra?.currency : 'symbol'
                    }}</mat-button-toggle
                  >
                }
                @if (isChild) {
                  <mat-button-toggle
                    [disabled]="!bookingDate[1]"
                    value="{{ extra?.childAmount }}-{{ index }}"
                    class="peak_button"
                    (click)="bookingDate[1] ? updateTravelCard(1, extra) : null"
                    >{{
                      extra?.childAmount | currency: extra?.currency : 'symbol'
                    }}</mat-button-toggle
                  >
                }
              </div>
            }
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
  }
  @if (noOfCards >= 3) {
    <div class="travel-card-item">
      <div class="flex-column-container travel-card-box">
        <p i18n="@@travelCardDate">Date of Travel:</p>
        <ngbd-datepicker-i18n class="date">
          <i
            class="ico-calendar combo-box-icon cursor_pointer"
            (click)="d3.toggle()"
            aria-hidden="true"
          ></i>
          <input
            autocomplete="off"
            placeholder="DD/MM/YYYY"
            i18n-placeholder
            class="combo-box"
            [minDate]="startDate"
            [startDate]="startDate"
            [(ngModel)]="bookingDate[2]"
            [navigation]="'arrows'"
            (click)="d3.toggle(); updateState()"
            ngbDatepicker
            [markDisabled]="isDisabled"
            #d3="ngbDatepicker"
            [container]="'body'"
            name="dp3"
            firstDayOfWeek="7"
            id="dp3"
            aria-labelledby="rail-outbound-date"
          />
          <!-- <i class="ico-clock combo-box-icon combo-box-icon--right"></i> -->
          <span id="rail-outbound-date" hidden i18n="AriaRailOutboundDate">Outbound date</span>
        </ngbd-datepicker-i18n>
        <div class="flex-row-container">
          <p class="london_zones london_zones_1" i18n="@@travelCardZone4">London Zone 1-4</p>
          <p class="london_zones london_zones_2" i18n="@@travelCardZone6">London Zone 1-6</p>
        </div>
        <div class="flex-row-container">
          <mat-button-toggle-group
            [disabled]="!bookingDate[2]"
            multiple
            (change)="toggleChange($event, 2)"
            [hideMultipleSelectionIndicator]="hideMultipleSelectionIndicator()"
            class="toggle_group"
            name="card-2"
          >
            @for (
              extra of outboundRailJourneyOption?.ticketExtras;
              track extra;
              let index = $index
            ) {
              <div class="flex-column-container toggle_container">
                <p>{{ extra?.description?.includes('Peak') ? 'Off-Peak' : 'Peak' }}</p>
                @if (isAdult) {
                  <mat-button-toggle
                    [disabled]="!bookingDate[2]"
                    class="peak_button"
                    value="{{ extra?.adultAmount }}-{{ index }}"
                    (click)="bookingDate[2] ? updateTravelCard(2, extra) : null"
                    >{{
                      extra?.adultAmount | currency: extra?.currency : 'symbol'
                    }}</mat-button-toggle
                  >
                }
                @if (isChild) {
                  <mat-button-toggle
                    [disabled]="!bookingDate[2]"
                    value="{{ extra?.childAmount }}-{{ index }}"
                    class="peak_button"
                    (click)="bookingDate[2] ? updateTravelCard(2, extra) : null"
                    >{{
                      extra?.childAmount | currency: extra?.currency : 'symbol'
                    }}</mat-button-toggle
                  >
                }
              </div>
            }
          </mat-button-toggle-group>
        </div>
      </div>
    </div>
  }
</div>
<div class="modal-footer">
  <button
    type="button"
    title="Cancel Choice"
    (click)="activeModal.close(false)"
    appButton="small"
    class="small-button--no"
    i18n="@@modalCancel"
  >
    Cancel
  </button>
  @if (!isSkip) {
    <button id="travel-card-OK" type="button" appButton="small" (click)="submit()" i18n="@@modalOK">
      Ok
    </button>
  }
  @if (isSkip) {
    <button type="button" appButton="small" (click)="submit()" i18n="@@modalSkip">Skip</button>
  }
</div>
